// RAMI_ONLINE_LANGUAGE_COOKIES
import { MAIN_LANGUAGE } from "../constants";
// import { getCookie } from "./cookie";

export default (to) => ({ 
    pathname: to, 
    // search: `?lang=${getCookie(RAMI_ONLINE_LANGUAGE_COOKIES) || MAIN_LANGUAGE}` 
    search: `?lang=${MAIN_LANGUAGE}` 
})